import React, { Component } from 'react';
import PropTypes from 'prop-types';

const InputField = (props) => {
  const {
    small = null,
    placeholder = '',
    label = null,
    id = null,
    value = null,
    onChange = () => {}
  } = props;
  const {
    labelClass = '',
    inputClass = '',
    formClass = 'form-group form-row',
    invalidFeedback = false,
    areAddressDetailsValid = true,
    ...inputProps
  } = props;

  return (
    <div className={formClass}>
      { id && label &&
        <label htmlFor={id} className={`${labelClass}`}>
          {label}
        </label>
      }
      <div className={inputClass}>
        <input className="form-control"
          style={{ 'borderColor': areAddressDetailsValid ? null : 'red' }}
          {...inputProps}
        />
        { invalidFeedback &&
          <div className="invalid-feedback">
            {invalidFeedback}
          </div>
        }
      </div>


    { small &&
      <small className="form-text text-muted">
        {small}
      </small>
    }

    </div>
  );
};

InputField.PropTypes = {
  small: PropTypes.object || PropTypes.string,
  placeholder: PropTypes.string,
  label: PropTypes.string,
  id: PropTypes.string,
  onChange: PropTypes.func
};

export default InputField;



// WEBPACK FOOTER //
// ./src/Common/InputField.js